export enum ProfileUpdateError {
    EMAIL_TAKEN,
    PHOTO_UPLOAD_FAIL,
    FIREBASE_ERROR,
    UNKNOWN_ERROR
}